class ScheduleItemHelper {
  scheduleItemTitle (scheduledItem) {
    return this.hasYearMakeOrModel(scheduledItem) ? this.yearMakeModel(scheduledItem) : scheduledItem.description;
  }

  yearMakeModel (scheduledItem) {
    var str = '';
    if ((scheduledItem.modelYear || null) != null) {
      str = scheduledItem.modelYear + ' ';
    }

    if ((scheduledItem.manufacturer || null) != null) {
      str = str + scheduledItem.manufacturer + ' ';
    }

    if ((scheduledItem.model || null) != null) {
      str = str + scheduledItem.model + ' ';
    }

    return str;
  }

  hasYearMakeOrModel (scheduledItem) {
    if ((scheduledItem.modelYear || null) != null) {
      return true;
    }

    if ((scheduledItem.manufacturer || null) != null) {
      return true;
    }

    if ((scheduledItem.model || null) != null) {
      return true;
    }

    return false;
  }
}

var x = new ScheduleItemHelper();
export default x;
